import { GetUsers } from "./ApiCalls/user/getUsers";
import { GetUsersSelect } from "./ApiCalls/user/getUsersSelect";
import { PostUser } from "./ApiCalls/user/postUser";
import { PatchUser } from "./ApiCalls/user/patchUser";
import { DisableUser } from "./ApiCalls/user/disabledUser";
import i18n from 'i18next';
import { GetUser } from "./ApiCalls/user/getUser";


const authInfoString = localStorage.getItem("authInfo");
const authInfo = authInfoString ? JSON.parse(authInfoString) : {};
const environment = authInfo.environment;
const modifiedBy = authInfo.idUser;

export async function GetUserservice(idUser) {
    try {
        const userData = await GetUser(idUser);

        const user = {    
            user: userData.user.user1,
            nif: userData.user.nif ? userData.user.nif : null,
            mail: userData.user.mail,
            name: userData.user.name,
            surname: userData.user.surname,
            rol: userData.rol ? userData.rol.name : `${i18n.t("services:services.noRole")}`,
            enabled: userData.user.enabled,
        }

        return user;
    } catch (error) {
        // console.error("Error during login:", error);
        // Manejar el error
        throw error;
    }
}


export async function GetUsersService() {
    try {
        const data = await GetUsers(environment);

        const userData = data.map(userData => ({
            user: userData.user.user1,
            nif: userData.user.nif ? userData.user.nif : "-----------",
            mail: userData.user.mail,
            name: userData.user.name,
            surname: userData.user.surname,
            rol: userData.rol ? userData.rol.name : `${i18n.t("services:services.noRole")}`,
            enabled: userData.user.enabled,
        }));

        return userData;
    } catch (error) {
        // console.error("Error during login:", error);
        // Manejar el error
        throw error;
    }
}
export async function GetUsersSelectService() {
    try {
        const data = await GetUsersSelect(environment);

        const userData = data.map(userData => ({
            user: userData.user.user1,
            nif: userData.user.nif ? userData.user.nif : "",
            mail: userData.user.mail,
            name: userData.user.name,
            surname: userData.user.surname,
            rol: userData.rol ? userData.rol.name : `${i18n.t("services:services.noRole")}`,
            enabled: userData.user.enabled,
        }));

        return userData;
    } catch (error) {
        // console.error("Error during login:", error);
        // Manejar el error
        throw error;
    }
}

export async function PostUserService(user) {
    try {
        const userData = await PostUser(user, modifiedBy, environment);

        const userResponse =
            ('user' in userData && 'user1' in userData.user)
                ? {
                    user: userData.user.user1,
                    nif: userData.user.nif,
                    mail: userData.user.mail,
                    name: userData.user.name,
                    surname: userData.user.surname,
                    rol: userData.rol ? userData.rol.name : null,
                }
                : userData.message
        return userResponse;

    } catch (error) {
        // console.error("Error during login:", error);
        // Manejar el error
        throw error;
    }
}

export async function PatchUserService(user, idUser) {
    try {
        const userData = await PatchUser(user, modifiedBy, idUser);
        const userResponse =
            ('user' in userData && 'user1' in userData.user)
                ? {
                    user: userData.user.user1,
                    nif: userData.user.nif,
                    mail: userData.user.mail,
                    name: userData.user.name,
                    surname: userData.user.surname,
                    rol: userData.rol ? userData.rol.name : null,
                }
                : userData.message

        return userResponse;
    } catch (error) {
        // console.error("Error during login:", error);
        // Manejar el error
        throw error;
    }
}

export async function DisabledUserService(user, idUser) {
    try {
        if (idUser === modifiedBy) {
            let error = {
                msg: `${i18n.t("services:services.cantDisable")}`
            };
            return error
        }

        const userData = await DisableUser(user, modifiedBy, idUser);
     

        return userData;


        ;

    } catch (error) {
        console.error("Error during disable user:", error);
        // Manejar el error
        throw error;
    }
}
